import script from "./CRMDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./CRMDetailsPage.vue?vue&type=style&index=0&id=31fb68be&lang=css"
import "./CRMDetailsPage.vue?vue&type=style&index=1&id=31fb68be&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31fb68be"]])

export default __exports__